module.exports = __webpack_public_path__ + "btn_delete.png";